import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Layout, Modal } from "components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faRecycle } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { resendOTP, verifyOTP } from "services/api-service";
import { useSelector } from "react-redux";
import { DEFAULT_ROUTE } from "constants/route";
import { HomeButton, NextButton } from "../CommonUI";
import { InputText } from "components/CommonUI";

const SUCCESS = "SUCCESS";
const INVALID_OTP = "Invalid OTP";

const OTP_TIMEOUT = 30;

export default function OtpForm({ className = "", onClick }) {
  const navigate = useNavigate();

  const { nric, mobile } = useSelector((state) => state.appointment);
  const [otp, setOtp] = useState("");
  const [otpTime, setOtpTime] = useState(OTP_TIMEOUT);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState(null);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    resendOTP(nric, mobile.toString());
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (otpTime > 0) setOtpTime(otpTime - 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [otpTime]);

  const handleOnChangeOpt = (e) => {
    if (e.target.value.length > 6) {
      return;
    }
    setOtp(e.target.value);
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    const response = await verifyOTP(nric, mobile.toString(), otp);
    const data = response.data;

    if (!data?.validation) {
      setError(data.message || INVALID_OTP);
      return;
    }
    onClick && onClick();
  };

  const resend = () => {
    resendOTP(nric, mobile).then(({ data }) => {
      if (data.status === SUCCESS) {
        setIsSent(true);
      } else {
        setError(data.message);
      }
    });
    setOtpTime(OTP_TIMEOUT);
    setError();
    setOtp("");
  };

  const goPrevious = () => {
    setErrorMessage("");
    setIsOpenModal(false);
    navigate(-1);
  };

  const goHome = () => navigate(DEFAULT_ROUTE);

  const onConfirm = () => {
    // setIsOpenModal(true);
    goHome();
  };

  const onHideModal = () => setIsOpenModal(false);

  const footer = (
    <div>
      <Button
        className="btn left-button cmp-button pbs-style--primary rounded-pill me-3"
        onClick={onHideModal}
      >
        No
      </Button>
      <Button
        className="btn cmp-button pbs-style--primary rounded-pill"
        onClick={goHome}
      >
        Yes
      </Button>
    </div>
  );

  const body = (
    <div className="center">
      <h3>Contact OTP Verification</h3>
      <p>
        Your contact detail will not be updated if you cancel the OTP
        verification.
      </p>
      <p className="dark-green">Are you sure you want to cancel ?</p>
    </div>
  );

  return (
    <div className={className}>
      <div className="center">
        <Form className="form-box" onSubmit={handleVerifyOTP}>
          <div className="d-flex flex-column">
            <div className="mx-auto">
              <div className="container">
                <div className="center mb-4">
                  <h6 style={{ fontWeight: 700 }}>Mobile verification</h6>
                </div>
                <div className="d-flex flex-column align-items-start justify-content-start">
                  <Form.Group className="w-100">
                    <InputText
                      label="Enter OTP sent to your mobile number"
                      type="number"
                      placeholder=""
                      value={otp}
                      onChange={handleOnChangeOpt}
                      isInvalid={error != null}
                      errorMessage={error}
                      // maxLength={6}
                    />
                    <div style={{ textAlign: "left" }}>
                      {otpTime == 0 && (
                        <a
                          className="cmp-button cmp-button--link"
                          onClick={resend}
                          rel="noreferrer"
                        >
                          <span className="cmp-button__text">Resend OTP</span>
                        </a>
                      )}
                      {otpTime !== 0 && (
                        <span className="cmp-button__text">
                          Resend OTP in {otpTime > 0 ? otpTime : null} seconds
                        </span>
                      )}
                    </div>
                  </Form.Group>

                  {/* <div className="mb-2 text-justify">
                    Enter One-Time Password (OTP) send to your mobile number
                  </div>
                  {mobile && <div className="mb-2">({mobile})</div>}
                  <div className="w-100">
                    <Form.Group>
                      <Form.Control
                        type="number"
                        className="form-control"
                        placeholder=""
                        value={otp}
                        onChange={handleOnChangeOpt}
                        required
                      />
                    </Form.Group>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="form-footer flex-md-row flex-column-reverse justify-content-md-between justify-content-start align-items-sm-center align-items-end">
              {/* <div className="m-10" > */}
              <HomeButton onClick={onConfirm} />
              <div className="mobile-s-10" />
              {/* </div> */}

              {/* <Button
                  className={`btn-cstm cmp-button ${
                    otpTime > 0 ? "btn-light" : "btn-default"
                  }`}
                  type="button"
                  onClick={resend}
                  disabled={otpTime != 0}
                >
                  Resend OTP {otpTime > 0 ? otpTime : null}
                  <FontAwesomeIcon
                    icon={faRecycle}
                    className="btnIconR"
                    color="white"
                  />
                </Button> */}
              <NextButton
                text={"Verify OTP"}
                disabled={otp.length !== 6}
                type={"submit"}
              />
              {/* <Button
                  className="btn-cstm cmp-button btn-cstmGreen"
                  type="submit"
                  disabled={otp.length !== 6}
                >
                  Verify
                  <FontAwesomeIcon
                    icon={faAngleRight}
                    className="btnIconR"
                    color="white"
                  />
                </Button> */}
            </div>
          </div>
          {isSent && (
            // <div className="text-success">OTP has sent to your phone.</div>
            <div className="text-success"></div>
          )}
          {/* {error && <div className="text-red">{error}</div>} */}
        </Form>
      </div>
      <Modal
        isOpen={isOpenModal}
        body={body}
        footer={footer}
        closeButton={false}
      />
    </div>
  );
}
